var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center",attrs:{"bg-variant":this.color,"text-variant":"white","header":this.title}},[_c('b-card-text',[(this.path != null)?_c('h1',[_vm._v(_vm._s(_vm.records.length))]):_c('h1',[_vm._v("0")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }